import type { ReactNode } from "react";
import { EmptyState } from "./ui";

export type Column<T> = {
  key: string;
  label: ReactNode;
  width?: string;
  align?: "left" | "right" | "center";
  render: (item: T, index: number) => ReactNode;
};

export function DataTable<T extends { id?: string }>({ columns, rows, emptyTitle = "Brak danych", rowClassName, onRowClick }: { columns: Column<T>[]; rows: T[]; emptyTitle?: string; rowClassName?: (item: T) => string | undefined; onRowClick?: (item: T) => void }) {
  if (!rows.length) return <EmptyState title={emptyTitle} />;
  return (
    <div className="table-scroll">
      <table className="data-table">
        <colgroup>{columns.map((column) => <col key={column.key} style={{ width: column.width }} />)}</colgroup>
        <thead><tr>{columns.map((column) => <th key={column.key} style={{ textAlign: column.align }}>{column.label}</th>)}</tr></thead>
        <tbody>
          {rows.map((row, index) => (
            <tr key={row.id ?? index} className={rowClassName?.(row)} onClick={onRowClick ? () => onRowClick(row) : undefined}>
              {columns.map((column) => <td key={column.key} style={{ textAlign: column.align }}>{column.render(row, index)}</td>)}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
